import React from "react";

import { TabPanel as ATabPanel, TabPanelProps } from "@atlaskit/tabs";

export const TabPanel: React.FC<TabPanelProps> = (props) => <ATabPanel {...props} />;

export type { TabPanelProps };
